<template>
  <div class="container-xxl flex-grow-1 container-p-y">
    <div class="card mb-6">
      <div class="card-header d-flex justify-content-between align-items-center">
        <div>
          <h4 class="mb-1">{{ $t("accounts.traffic_usage_chart") }}</h4>
        </div>

        <div class="card-action-element ms-auto py-0">
          <div class="dropdown">
            <button type="button" class="btn dropdown-toggle px-0" data-bs-toggle="dropdown" aria-expanded="false">
              <i class="ti ti-calendar"></i>
            </button>
            <ul class="dropdown-menu dropdown-menu-end">
              <li>
                <a href="javascript:void(0);" class="dropdown-item d-flex align-items-center">Today</a>
              </li>
              <li>
                <a href="javascript:void(0);" class="dropdown-item d-flex align-items-center">Yesterday</a>
              </li>
              <li>
                <a href="javascript:void(0);" class="dropdown-item d-flex align-items-center">Last 7 Days</a>
              </li>
              <li>
                <a href="javascript:void(0);" class="dropdown-item d-flex align-items-center">Last 30 Days</a>
              </li>
              <li>
                <hr class="dropdown-divider" />
              </li>
              <li>
                <a href="javascript:void(0);" class="dropdown-item d-flex align-items-center">Current Month</a>
              </li>
              <li>
                <a href="javascript:void(0);" class="dropdown-item d-flex align-items-center">Last Month</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div id="internetUsageChart"></div>
      </div>
    </div>
    <div class="card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h4 class="mb-1">{{ $t("accounts.live_speed_chart") }}</h4>
        <button class="btn btn-danger waves-effect waves-light" @click="confirmDisconnect">
          <span>
            <i class="ti ti-wifi-off ti-xs me-2"></i>
            <span>{{ $t("accounts.disconnect") }}</span>
          </span>
        </button>
      </div>
      <div class="card-body">
        <div id="internetLiveUsageChart"></div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        const chartEl = document.querySelector("#internetUsageChart");

        const options = {
          series: [
            {
              name: "Download",
              data: [4.2, 5.1, 3.8, 6.3, 8.4, 7.2, 5.5, 6.7, 4.9, 6.1],
            },
            {
              name: "Upload",
              data: [1.8, 2.1, 1.5, 2.4, 3.2, 2.8, 2.2, 2.6, 1.9, 2.5],
            },
          ],
          chart: {
            type: "bar",
            height: 320,
            toolbar: { show: false },
          },
          plotOptions: {
            bar: {
              borderRadius: 9,
              columnWidth: "80%",
            },
          },
          colors: ["#7367F0", "#28C76F"],
          xaxis: {
            categories: [
              "10:00", "10:05", "10:10", "10:15", "10:20",
              "10:25", "10:30", "10:35", "10:40", "10:45",
            ],
            labels: {
              style: {
                fontSize: "12px"
              }
            },
            axisBorder: {
              show: false
            },
            axisTicks: {
              show: false
            },
          },
          yaxis: {
            labels: {
              formatter: (val) => `${val} Mbps`,
              style: {
                fontSize: "12px"
              }
            },
          },
          grid: {
            strokeDashArray: 5,
          },
          tooltip: {
            y: {
              formatter: (val) => `${val} Mbps`,
            },
          },
          legend: {
            show: true,
            position: "bottom",
            fontSize: "14px",

          },
        };

        if (chartEl) {
          const chart = new ApexCharts(chartEl, options);
          chart.render();
        }
      }, 50);
    });


    this.$nextTick(() => {
      setTimeout(() => {
        const chartEl = document.querySelector("#internetLiveUsageChart");

        const options = {
          series: [
            {
              name: "Download",
              type: "line",
              data: [4.2, 5.1, 3.8, 6.3, 8.4, 7.2, 5.5, 6.7, 4.9, 6.1],
            },
            {
              name: "Upload",
              type: "line",
              data: [1.8, 2.1, 1.5, 2.4, 3.2, 2.8, 2.2, 2.6, 1.9, 2.5],
            },
          ],
          chart: {
            height: 320,
            type: "line",
            toolbar: { show: false },
            zoom: { enabled: false },
          },
          stroke: {
            curve: "smooth",
            width: 3,
          },
          markers: {
            size: 5,
            hover: { size: 6 },
          },
          colors: ["#7367F0", "#28C76F"],
          xaxis: {
            categories: [
              "2025-04-09 10:00:00",
              "2025-04-09 10:05:30",
              "2025-04-09 10:10:45",
              "2025-04-09 10:15:00",
              "2025-04-09 10:20:15",
              "2025-04-09 10:25:30",
              "2025-04-09 10:30:00",
              "2025-04-09 10:35:45",
              "2025-04-09 10:40:00",
              "2025-04-09 10:45:15",
            ],
            tooltip: {
              enabled: false,
            },
            labels: {
              show: false,
            },
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
          },
          yaxis: {
            min: 0,
            tickAmount: 4,
            labels: {
              formatter: (val) => `${Number(val).toFixed(1)} Mbps`,
              style: {
                fontSize: "13px",
              },
            },
          },
          legend: {
            show: true,
            position: "bottom",
            fontSize: "14px",
            fontWeight: 500,
            markers: {
              width: 10,
              height: 10,
              radius: 12,
            },
            itemMargin: {
              horizontal: 10,
              vertical: 4,
            },
            labels: {
              colors: "#5d596c",
              useSeriesColors: false,
            },
          },
          tooltip: {
            shared: true,
            x: {
              show: true,
            },
            y: {
              formatter: (val) => `${val} Mbps`,
            },
          },
          grid: {
            strokeDashArray: 5,
          },
        };

        if (chartEl) {
          const chart = new ApexCharts(chartEl, options);
          chart.render();

          setTimeout(() => {
            chart.resize();
          }, 150);
        }
      }, 50);
    });
  },
};
</script>